import { BRAND } from "../config/brand";
import BrandMark from "./BrandMark";
import "./footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <BrandMark variant="footer" showTagline={false} />

      <p className="app-footer__tagline">{BRAND.footerLine}</p>

      <p className="app-footer__credit">
        Engineered by <strong>{BRAND.developer}</strong> · {year}
      </p>
    </footer>
  );
}
